export default "__VITE_ASSET__D7e9KZ8W__"